import { cn } from "@/lib/classNames";

type MapChromeTheme = {
  toolbarShell: string;
  titlePlaque: string;
  titleEyebrow: string;
  titleLabel: string;
  floatingPanel: string;
  floatingPanelCompact: string;
  subtlePanel: string;
  switcherTrack: string;
  switcherIndicator: string;
  tabButtonActive: string;
  tabButtonIdle: string;
  toolButtonActive: string;
  toolButtonIdle: string;
  tooltip: string;
  textPrimary: string;
  textMuted: string;
  textSubtle: string;
  divider: string;
  actionButtonActive: string;
  actionButtonIdle: string;
  iconToggleActive: string;
  iconToggleIdle: string;
  sizeOptionSelected: string;
  sizeOptionIdle: string;
  modalBackdrop: string;
  modalPanel: string;
  pickerTitle: string;
  pickerShortcut: string;
  pickerError: string;
  pickerActionButton: string;
  pickerCreateCard: string;
  pickerCreateCardAccent: string;
  pickerDeleteButton: string;
  breadcrumbRail: string;
  breadcrumbButton: string;
  breadcrumbButtonCurrent: string;
  breadcrumbMenu: string;
  breadcrumbMenuItem: string;
  breadcrumbMenuItemCurrent: string;
  carouselArrow: string;
  carouselEdgeFadeLeft: string;
  carouselEdgeFadeRight: string;
  cardIdleRing: string;
  cardSelectedRing: string;
  cardFallback: string;
  cardScrim: string;
  cardFooter: string;
  cardFooterStack: string;
  cardFooterTitle: string;
  cardFooterMeta: string;
  cardBadge: string;
  cardBadgeMuted: string;
  cardHotkeyBadge: string;
  sectionHeading: string;
  input: string;
  textarea: string;
  select: string;
  checkbox: string;
  secondaryButton: string;
  primaryButton: string;
  destructiveButton: string;
};
const MAP_CHROME_THEME: MapChromeTheme = {
      toolbarShell:
        "bg-transparent text-neutral-950",
      titlePlaque:
        "bg-[#fff2d9] text-neutral-950 shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]",
      titleEyebrow: "text-neutral-950/52",
      titleLabel: "text-neutral-950",
      floatingPanel:
        "rounded-2xl border-[3px] border-neutral-950 bg-[#fffaf1]/95 text-neutral-950 backdrop-blur-md",
      floatingPanelCompact:
        "rounded-xl border-[2px] border-neutral-950 bg-[#fffaf1]/95 text-neutral-950 backdrop-blur-md",
      subtlePanel:
        "rounded-xl border-[2px] border-neutral-950/15 bg-[#fff2d9]/72 backdrop-blur-sm",
      switcherTrack:
        "relative mb-1 grid w-full grid-cols-2 items-center rounded-xl border-[2px] border-neutral-950 bg-[#fff2d9]/78 p-0.5",
      switcherIndicator:
        "pointer-events-none absolute inset-y-0.5 left-0.5 w-[calc(50%-2px)] rounded-[0.7rem] border-[2px] border-neutral-950 bg-neutral-950 shadow-sm transition-transform duration-200 ease-out",
      tabButtonActive: "text-[#fff7ec]",
      tabButtonIdle: "text-neutral-950/55 hover:text-neutral-950",
      toolButtonActive:
        "border-[2px] border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-sm",
      toolButtonIdle:
        "border-[2px] border-transparent text-neutral-950/68 hover:border-neutral-950/15 hover:bg-[#fff2d9] hover:text-neutral-950",
      tooltip:
        "border-[2px] border-neutral-950 bg-[#fffaf1] text-neutral-950",
      textPrimary: "text-neutral-950",
      textMuted: "text-neutral-950/72",
      textSubtle: "text-neutral-950/52",
      divider: "bg-neutral-950/15",
      actionButtonActive:
        "border-[2px] border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-sm",
      actionButtonIdle:
        "border-[2px] border-neutral-950/15 bg-[#fff2d9]/72 text-neutral-950 transition-colors hover:bg-[#ffe7bc]",
      iconToggleActive:
        "border-[2px] border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-sm",
      iconToggleIdle:
        "border-[2px] border-transparent text-neutral-950/58 transition-colors hover:border-neutral-950/15 hover:bg-[#fff2d9] hover:text-neutral-950",
      sizeOptionSelected:
        "border-[2px] border-neutral-950 bg-neutral-950 text-[#fff7ec] shadow-sm",
      sizeOptionIdle:
        "border-[2px] border-neutral-950/15 bg-[#fff2d9]/72 text-neutral-950/78 hover:border-neutral-950/30 hover:bg-[#ffe7bc] hover:text-neutral-950",
      modalBackdrop:
        "bg-[rgba(247,243,235,0.76)] backdrop-blur-sm backdrop-brightness-100",
      modalPanel:
        "rounded-[28px] border-[3px] border-neutral-950 bg-[#fffaf1]/96 text-neutral-950 shadow-[18px_18px_0_rgba(19,19,19,0.16)] backdrop-blur-md",
      pickerTitle: "text-neutral-950",
      pickerShortcut: "text-neutral-950/45",
      pickerError:
        "mb-4 rounded-xl border-[2px] border-[#9c4c32] bg-[#fff2d9] px-4 py-2 text-sm text-[#5d2f26]",
      pickerActionButton:
        "flex shrink-0 items-center gap-2 rounded-xl border-[2px] border-neutral-950/15 bg-white px-4 py-2.5 text-sm font-medium text-neutral-950 shadow-sm transition-colors hover:border-neutral-950/30 hover:bg-white",
      pickerCreateCard:
        "flex h-[340px] w-[340px] shrink-0 flex-col items-center justify-center gap-2 rounded-2xl border-[2px] border-dashed border-neutral-950/25 bg-[#fff2d9]/55 text-neutral-950 transition-all hover:border-neutral-950 hover:bg-[#fff2d9]",
      pickerCreateCardAccent: "text-neutral-950/42",
      pickerDeleteButton:
        "absolute right-2 top-2 z-10 rounded-lg border-[2px] border-neutral-950 bg-[#fffaf1]/94 px-2 py-1 text-xs font-medium text-[#9c4c32] transition-colors hover:bg-[#fff2d9] hover:text-[#5d2f26] disabled:cursor-not-allowed disabled:opacity-60",
      breadcrumbRail:
        "relative z-20 inline-flex flex-wrap items-center gap-1 rounded-lg border border-neutral-950/12 bg-[#fffaf1]/90 p-1 shadow-[0_8px_20px_rgba(19,19,19,0.05)] backdrop-blur-md",
      breadcrumbButton:
        "inline-flex items-center gap-1.5 rounded-md border border-neutral-950/12 bg-white px-2.5 py-1.5 text-[12px] font-semibold tracking-[0.01em] text-neutral-950 transition-colors hover:bg-[#f3efe7] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3e664d]",
      breadcrumbButtonCurrent:
        "border-neutral-950/25 bg-white text-neutral-950 shadow-sm",
      breadcrumbMenu:
        "absolute left-0 top-full z-50 mt-1 min-w-[11rem] rounded-lg border border-neutral-950 bg-[#fffaf1] p-1 shadow-[8px_8px_0_rgba(19,19,19,0.1)]",
      breadcrumbMenuItem:
        "flex w-full items-center justify-between rounded-md px-2.5 py-2 text-left text-sm text-neutral-950/78 transition-colors hover:bg-[#f3efe7] hover:text-neutral-950",
      breadcrumbMenuItemCurrent: "bg-[#f3efe7] text-neutral-950",
      carouselArrow:
        "rounded-full border-[2px] border-neutral-950/15 bg-[#fffaf1]/92 p-2 text-neutral-950/70 shadow-lg transition-colors hover:bg-[#fff2d9] hover:text-neutral-950",
      carouselEdgeFadeLeft:
        "bg-linear-to-r from-[#fffaf1] via-[#fffaf1]/78 to-transparent",
      carouselEdgeFadeRight:
        "bg-linear-to-l from-[#fffaf1] via-[#fffaf1]/78 to-transparent",
      cardIdleRing:
        "border border-neutral-950/14 hover:border-neutral-950/34",
      cardSelectedRing:
        "border-2 border-neutral-950 shadow-[0_10px_24px_rgba(19,19,19,0.16)] scale-[1.02]",
      cardFallback: "bg-[#ece4d4]",
      cardScrim:
        "bg-transparent",
      cardFooter:
        "flex items-center justify-between rounded-b-[inherit] border-t border-neutral-950/12 bg-[#fffaf1]/94 px-3 py-2",
      cardFooterStack:
        "rounded-b-[inherit] border-t border-neutral-950/12 bg-[#fffaf1]/94 px-3 py-2",
      cardFooterTitle: "text-sm font-semibold text-neutral-950",
      cardFooterMeta: "text-xs text-neutral-950/55",
      cardBadge:
        "rounded-full border border-neutral-950/15 bg-[#fffaf1]/94 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-neutral-950/80 shadow-sm",
      cardBadgeMuted:
        "rounded bg-[#fffaf1]/94 px-2 py-1 text-[10px] font-medium text-neutral-950/72 shadow-sm",
      cardHotkeyBadge:
        "pointer-events-none absolute left-2 top-2 z-10 rounded border border-neutral-950/12 bg-[#fffaf1]/94 px-1 py-0.5 text-[10px] font-medium tabular-nums text-neutral-950/65 shadow-sm",
      sectionHeading: "text-sm font-semibold uppercase tracking-[0.2em] text-neutral-950/45",
      input:
        "w-full rounded-xl border-[2px] border-neutral-950 bg-[#fffaf1] px-3 py-2 text-sm text-neutral-950 placeholder:text-neutral-950/35 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3e664d]",
      textarea:
        "w-full resize-none rounded-xl border-[2px] border-neutral-950 bg-[#fffaf1] px-3 py-2 text-sm text-neutral-950 placeholder:text-neutral-950/35 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3e664d]",
      select:
        "w-full rounded-xl border-[2px] border-neutral-950 bg-[#fffaf1] px-3 py-2 text-sm text-neutral-950 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#3e664d]",
      checkbox: "accent-[#3e664d]",
      secondaryButton:
        "rounded-xl border-[2px] border-neutral-950 bg-[#fff2d9] text-neutral-950 transition-colors hover:bg-[#ffe7bc] disabled:cursor-not-allowed disabled:opacity-60",
      primaryButton:
        "rounded-xl border-[2px] border-neutral-950 bg-[#3e664d] text-[#fff7ec] transition-colors hover:bg-[#23443a] disabled:cursor-not-allowed disabled:opacity-60",
      destructiveButton:
        "rounded-xl border-[2px] border-neutral-950 bg-[#9c4c32] text-[#fff7ec] transition-colors hover:bg-[#5d2f26] disabled:cursor-not-allowed disabled:opacity-60",
};

export function getMapChromeTheme(): MapChromeTheme {
  return MAP_CHROME_THEME;
}

export function mapChromeButtonClassName(
  theme: MapChromeTheme,
  active: boolean,
  baseClassName: string,
  {
    activeClassName = theme.actionButtonActive,
    idleClassName = theme.actionButtonIdle,
  }: {
    activeClassName?: string;
    idleClassName?: string;
  } = {},
): string {
  return cn(baseClassName, active ? activeClassName : idleClassName);
}
